import { useMemo, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import './CompanyGroupInput.scss';

/**
 * Grupo empresarial: texto libre con sugerencias de los grupos existentes.
 * Es el input del modal "Crear empresa"; la Ficha Cliente usa el mismo.
 */
export default function CompanyGroupInput({
  id,
  value = '',
  groups = [],
  onChange,
  onSelect,
  onFocus,
  onBlur,
  placeholder,
  disabled = false,
}) {
  const [showSuggestions, setShowSuggestions] = useState(false);

  const filteredGroups = useMemo(() => {
    const q = (value || '').trim().toLowerCase();
    if (!q) return groups;
    return groups.filter((group) => group.toLowerCase().includes(q));
  }, [groups, value]);

  const handleChange = (e) => {
    onChange?.(e.target.value);
    setShowSuggestions(true);
  };

  const handleFocus = (e) => {
    setShowSuggestions(true);
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    // Delay para permitir click en sugerencias
    setTimeout(() => {
      setShowSuggestions(false);
    }, 200);
    onBlur?.(e);
  };

  const selectGroup = (groupName) => {
    onChange?.(groupName);
    onSelect?.(groupName);
    setShowSuggestions(false);
  };

  return (
    <div className="group-input-container">
      <input
        id={id}
        type="text"
        value={value}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
      />
      {showSuggestions && !disabled && filteredGroups.length > 0 && (
        <div className="group-suggestions">
          {filteredGroups.map((group) => (
            <div
              key={group}
              className="group-suggestion-item"
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => selectGroup(group)}
            >
              <Icon name="folder outline" />
              {group}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
